import { Deserializable } from '../_common/deserializable';

export class SubscriptionPerformance implements Deserializable{
    shortCode: string;
    keyword: string;
    operator: string;
    client: string;
    timezone: string;
    timezoneOffset: number;
    reports: Array<any>;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
